import { render } from "./AccountControls.vue?vue&type=template&id=0af35790&scoped=true"
import script from "./AccountControls.vue?vue&type=script&lang=js"
export * from "./AccountControls.vue?vue&type=script&lang=js"

import "./AccountControls.vue?vue&type=style&index=0&id=0af35790&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af35790"]])

export default __exports__